export default __webpack_public_path__ + "static/media/submit.851a56ff.svg";